import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';
import { Resources } from 'constants/resources';

import { useMemo } from 'react';

import { useGetList } from 'react-admin';
import { MerchantCredentials } from 'types/embedded/merchant';

export const useUniqueProvidersFromCredentials = (merchantId: string | undefined) => {
  const { data, isLoading } = useGetList<MerchantCredentials>(
    Resources.MerchantCredentials,
    {
      pagination: UNLIMITED_PAGINATION_PARAMS,
      filter: { merchant: merchantId },
    },
    { enabled: !!merchantId },
  );

  const providers = useMemo(() => {
    if (!data) {
      return [];
    }

    const uniqueMap = new Map<string, { id: string; name: string }>();

    data.forEach((credential) => {
      const provider = credential.provider;
      if (provider?.['@id'] && !uniqueMap.has(provider['@id'])) {
        uniqueMap.set(provider['@id'], {
          id: provider['@id'],
          name: provider.name ?? '',
        });
      }
    });

    return Array.from(uniqueMap.values());
  }, [data]);

  return { providers, isLoading };
};
